import React             from 'react';
import { Redirect }      from 'react-router-dom';
import Progress   from './Progress';

export const ProgressConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path      : '/progress',
            component : Progress,
            permission: { component_name: 'progress', permission_type: 'list' },
        },
        // {
        //     path: '/student_progress',
        //     component: () => <Redirect to="/dashboard" />,
        //     permission: { component_name: 'student', permission_type: 'list' },
        // }
    ]
};



// WEBPACK FOOTER //
// src/main/content/progress/ProgressConfig.js